// src/components/ActivityLogs.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Container, Typography, Box, Paper, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';
const API_URL = process.env.REACT_APP_API_URL || '';
const ActivityLogs = () => {
    const [logs, setLogs] = useState([]);
    const token = localStorage.getItem('token');

    const fetchLogs = async () => {
        try {
            const response = await axios.get(`${API_URL}/api/users/activity-logs`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setLogs(response.data);
        } catch (error) {
            console.error('Error fetching activity logs:', error);
        }
    };

    useEffect(() => {
        fetchLogs();
    }, [token]);

    return (
        <Container maxWidth="lg">
            <Box sx={{ mt: 4 }}>
                <Typography variant="h4" gutterBottom>Logi aktywności użytkowników</Typography>
                <Paper sx={{ p: 2 }}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>ID</TableCell>
                                <TableCell>Nazwa użytkownika</TableCell>
                                <TableCell>Typ akcji</TableCell>
                                <TableCell>Szczegóły akcji</TableCell>
                                <TableCell>Adres IP</TableCell>
                                <TableCell>Data</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {logs.map(log => (
                                <TableRow key={log.id}>
                                    <TableCell>{log.id}</TableCell>
                                    <TableCell>{log.username}</TableCell>
                                    <TableCell>{log.action_type}</TableCell>
                                    <TableCell>{log.action_details}</TableCell>
                                    <TableCell>{log.ip_address}</TableCell>
                                    <TableCell>{new Date(log.created_at).toLocaleString()}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </Paper>
            </Box>
        </Container>
    );
};

export default ActivityLogs;